import { withInstall } from '../utils';
import _Icon from './Icon';
export var Icon = withInstall(_Icon);
export default Icon;